import React, { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import Color from 'color'
import { palette } from '../Theme/Theme'

class AuthorizedRoute extends Component {
  
    render() {
      const { component: Component, pending, logged, ...rest } = this.props
      return (
        <Route {...rest} render={props => {
          if (pending) return this.renderLogo()
          return logged
            ? <Component {...this.props} />
            : <Redirect to="/welcome" />
        }} />
      )
    }

    renderLogo = () => {
      const { classes } = this.props
      return (
          <div className={classes.LogoContainer}>
              <h1 className={classes.Message}>Loading</h1>
          </div>
      )
    }
}

const style = {
    LogoContainer: {
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        background: `linear-gradient(45deg, ${Color(palette.pink).darken(0.6).alpha(0.9)}, ${Color(palette.purple).darken(0.6).alpha(0.9)}, ${Color(palette.blue).darken(0.6).alpha(0.9)}, ${Color(palette.teal).darken(0.6).alpha(0.9)})`
    },
    Message: {
        color: 'white',
        fontSize: '4rem',
        fontWeight: '300',
        opacity: '0',
        animationName: 'pulse',
        animationDuration: '1.5s',
        animationIterationCount: 'infinite',
        animationDirection: 'alternate'
    },
    '@keyframes pulse': {
        from: {
            opacity: '0'
        },
        to: {
            opacity: '1'
        }
    }
}
  
const stateToProps = (state) => ({
    pending: state.mainState.loggedUserState.pending,
    logged: state.mainState.loggedUserState.logged
})

export default connect(stateToProps)(injectSheet(style)(AuthorizedRoute))


// WEBPACK FOOTER //
// ./src/js/Components/AuthorizedRoute.jsx